export default {
      id: "photo_upload-usage",
      viewBox: "0 0 21 22",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#photo_upload",
      toString: function () {
        return this.url;
      }
    }